import { SuspenseContext } from 'components/Suspense'
import { useContext, useRef } from 'react'

/**
 * When used, will cause the nearest Suspense boundary to switch to client-only rendering (noSsr), and not render the children until hydration is complete.
 */
export function useClientOnlyRender() {
  const context = useContext(SuspenseContext)
  const isLockedRef = useRef(false)
  const isSsr = (typeof window === 'undefined')

  if (isSsr) {
    if (!isLockedRef.current) {
      isLockedRef.current = true
      context?.lockClientOnlyRender()
    }
  }
}
